import LogoTitle from '../../assets/images/logo-s.png';
import { Link } from 'react-router-dom';
import AnimatedLetter from '../AnimatedLetters';
import './index.scss';
import { useState, useEffect } from 'react';
import Logo from './Logo';
import { Loader } from 'react-loaders';

const Home = () => {

    const [letterClass, setLetterClass] = useState('text-animate');
    const nameArray = ['a', 'n', 'j', 'a', 'y', ','];
    const jobArray = ['C', 'S', ' ', 'S', 't', 'u', 'd', 'e', 'n', 't', '.'];

    useEffect(() => {
        const timer = setTimeout(() => {
            setLetterClass('text-animate-hover');
        }, 4000);
    
        return () => clearTimeout(timer);
    }, []);
    
    
    return (
        <>
        <div className="container home-page">

            <div className = "text-zone">

                <h1>
                     <span className = {letterClass}>H</span>
                    <span className = {`${letterClass} _12`}>i,</span> 
                    <br />
                    <span className = {`${letterClass} _13`}>I</span> 
                    <span className = {`${letterClass} _14`}>'m</span> 

                <img src = {LogoTitle} alt = "developer"/>
                <AnimatedLetter letterClass = {letterClass} strArray={nameArray} idx = {15}/>
                <br />
                <AnimatedLetter letterClass = {letterClass} strArray={jobArray} idx = {20}/>
                </h1>

                <h2>Problem Solver / ML Enthusiast / Backend Developer</h2>
                <Link to = "/contact" className = 'flat-button'>CONTACT ME</Link>
            </div>
            <Logo />
        </div>
        <Loader type="pacman" />
        </>
    );
    
}

export default Home; 